const ServiceProCardSkeleton = () => {
  return (
    <div className="flex flex-col w-full font-inter lg:flex-row p-4 sm:p-9 bg-white rounded-2xl border border-light-blue gap-4 animate-pulse">
      {/* Left Section */}
      <div className="w-full lg:max-w-[571px]">
        {/* User main details */}
        <div className="flex flex-col items-center gap-4 sm:flex-row sm:gap-[34px]">
          <div className="flex-shrink-0 w-32 h-32 md:w-40 md:h-40 rounded-full bg-gray-200"></div>
          <div className="py-4 sm:py-6 flex flex-col gap-3 w-full">
            <div className="w-24 h-6 bg-gray-300 rounded"></div>
            <div className="w-40 h-6 bg-gray-300 rounded"></div>
            <div className="w-32 h-5 bg-gray-300 rounded"></div>
          </div>
        </div>
        {/* Action buttons */}
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 mt-4">
          <div className="h-12 w-full sm:w-[214px] bg-gray-300 rounded-xl"></div>
          <div className="h-12 w-full sm:w-[214px] bg-gray-300 rounded-xl"></div>
        </div>
      </div>
      {/* Right Section */}
      <div className="flex flex-col gap-6 flex-1 mt-6 md:mt-0">
        {/* About Me */}
        <div className="flex flex-col gap-1.5">
          <div className="w-24 h-6 bg-gray-300 rounded"></div>
          <div className="w-full h-12 bg-gray-300 rounded"></div>
        </div>
        {/* Categories */}
        <div className="flex flex-col gap-1.5">
          <div className="w-24 h-6 bg-gray-300 rounded"></div>
          <div className="w-full h-8 bg-gray-300 rounded"></div>
        </div>
        {/* Skills */}
        <div className="flex flex-col gap-1.5">
          <div className="w-24 h-6 bg-gray-300 rounded"></div>
          <div className="w-full h-8 bg-gray-300 rounded"></div>
        </div>
      </div>
    </div>
  );
};

export default ServiceProCardSkeleton;
